export const getStudentParamList = `
    query getStudentParamList(
        $query: String, 
        $per_page: Int!,
        $relation: String,
        $relationUuid: String
    ) {
        students(
            page: 0, 
            per_page: $per_page, 
            query: $query, 
            unscoped: true,
            relation: $relation,
            relation_uuid: $relationUuid
        ) {
            data {
                id
                uuid
                email
                first_name
                last_name
            }
        }
    }
`
export const removeStudent = `
    mutation removeStudent($id: Int!) {
        removeStudent(id: $id) {
            id
        }
    }
`
export const removeStudents = `
    mutation removeStudents($student_ids: [Int]!) {
        removeStudents(student_ids: $student_ids) {
            id
        }
    }
`
export const resetStudentsTokens = `
    mutation resetStudentsTokens($student_ids: [Int]!) {
        resetStudentsTokens(student_ids: $student_ids) {
            id
            uuid
            token
        }
    }
`
export const addCourseToStudent = `
    mutation addCourseToStudent($course_id: Int!, $student_id: Int!) {
        addCourseToStudent(course_id: $course_id, student_id: $student_id) {
            id
        }
    }
`
export const addCourseToStudents = `
    mutation addCourseToStudents($course_id: Int!, $student_ids: [Int]!) {
        addCourseToStudents(course_id: $course_id, student_ids: $student_ids) {
            id
        }
    }
`
export const addStudentsToTeam = `
    mutation addStudentsToTeam($team_id: Int, $student_ids: [Int]!) {
        addStudentsToTeam(team_id: $team_id, student_ids: $student_ids) {
            id
        }
    }
`
export const addStudentsToEvent = `
    mutation addStudentsToEvent($event_id: Int, $student_ids: [Int]!) {
        addStudentsToEvent(event_id: $event_id, student_ids: $student_ids) {
            id
        }
    }
`